import apiClient from "../apiClient";

const resource = "Lookups";

export default {
    getLookups: () => apiClient.get(`${resource}`),
    getNationalities: () => apiClient.get(`${resource}/Nationalities`),
    getCities: () => apiClient.get(`${resource}/cities`),
    getMunicipalities: () => apiClient.get(`${resource}/Municipalities`),
    getBanks: () => apiClient.get(`${resource}/Banks`),
    getBranches: () => apiClient.get(`${resource}/Branches`),
    getAdministrations: () => apiClient.get(`${resource}/Administrations`),
    getDepartments: (administrationId) => apiClient.get(`${resource}/${administrationId}/Departments`),
    getJobs: () => apiClient.get(`${resource}/Jobs`),
    getJobGrades: () => apiClient.get(`${resource}/JobGrades`),
    getAdministrationsByType: (id) => apiClient.get(`${resource}/${id}/AdministrationsByType`),
    getJobGroups: () => apiClient.get(`${resource}/jobGroups`),
    getManagementEmployees: (params) => apiClient.get(`${resource}/ManagementEmployees?${params}`),
    getSpecialties: () => apiClient.get(`${resource}/Specialties`),
    getUniversities: () => apiClient.get(`${resource}/Universities`),
    getVacationsTypes: () => apiClient.get(`${resource}/vacationsTypes`),
    employeesSearch: (employeeNo) => apiClient.get(`${resource}/${employeeNo}/EmployeesSearch`),
    getUnits: () => apiClient.get(`${resource}/units`),
    getAllDepartments: () => apiClient.get(`${resource}/AllDepartments`),
    getAssignments: (id) => apiClient.get(`${resource}/${id}/Assignments`),
    getJobsByGroup: (id) => apiClient.get(`${resource}/${id}/JobsByGroup`),
    getjobGradesByAdminId: (id) => apiClient.get(`${resource}/${id}/jobGradesByAdminId`),
    
    getUnitsById: (id,typeId) => apiClient.get(`${resource}/${id}/UnitsById?typeId=${typeId}`),
    getEmployees: params => apiClient.get(`${resource}/Employees?${params}`),
    getEmployeesByAssignment: () => apiClient.get(`${resource}/EmployeesByAssignment`),
    getJobGradesForAdministratives: () => apiClient.get(`${resource}/jobGradesForAdministratives`),
    getAppointmentTypes: () => apiClient.get(`${resource}/appointmentTypes`),
    getLocalities: (id) => apiClient.get(`${resource}/${id}/localities`),

};